export default class User {
	constructor(
		name='',
		email='',
		role='',
		password=''
	){
		this.name = name;
		this.email = email;
		this.role = role;
		this.password = password;
	}
}